__turbopack_context__.v({
  "className": "orbitron_d9786591-module__8qPUFq__className",
});
